import React from 'react';
import ReactDOM from 'react-dom';
import '!style-loader!css-loader!react-selectize/themes/index.css';
import '!style-loader!css-loader!../quickView/selectizeOverrides.css';
import QuickViewControllerAsync from './QuickViewControllerAsync';
import { debounce } from '../shared/utils/common';

/*
  {
    ReactComponent: attachable-class-name
  }
*/

const connectableComponents = [
  {
    connectionClass: 'tl-quick-view',
    component: QuickViewControllerAsync,
    parentComponentId: 'tl-quick-view',
  },
];

window.qvBootstrapRegister = [];

window.quickViewBootstrap = {
  attachElement: (component, element, productHandle, autoSelectedSize, location) => {
    if (typeof element !== 'undefined' && element !== null) {
      ReactDOM.render(React.createElement(component, {
        productHandle,
        autoSelectedSize,
        location,
      }, null), element);
    }
  },

  bootstrap: (autoSelectedSize, location) => {
    connectableComponents.forEach((component) => {
      const elements = document.getElementsByClassName(component.connectionClass);
      const attachToElement = document.getElementById(component.parentComponentId);

      for (let i = 0; i < elements.length; i++) {
        const targetElement = elements.item(i);
        const productHandle = targetElement.getAttribute('data-product-handle');
        const templateName = targetElement.getAttribute('data-category');
        if (templateName) {
          location = templateName;
        }
        let register = {};

        register.handler = window.quickViewBootstrap.attachElement.bind(
          this, component.component, attachToElement, productHandle, autoSelectedSize, location);
        register.element = targetElement;

        targetElement.addEventListener('click', (e) => {
          e.preventDefault();

          if (register.handler) {
            register.handler();
          }
        });
        targetElement.classList.add('quick-view--attached');

        window.qvBootstrapRegister.push(register);
      }
    });
  },

  resetHandlers: () => {
    window.qvBootstrapRegister.map((register) => {
      register.element.removeEventListener('click', register.handler);
      // clear up the references so the GC can also clear them
      register.handler = null;
      register.element = null;
      return null;
    });

    window.qvBootstrapRegister = [];
  },

  reInitialize: debounce(() => {
    window.quickViewBootstrap.resetHandlers();
    window.quickViewBootstrap.bootstrap();
  }, 1000),

  initialize: () => {
    window.addEventListener('DOMContentLoaded', () => {
      window.quickViewBootstrap.bootstrap();
    });

    if (document && ['complete', 'interactive', 'loaded'].indexOf(document.readyState) > -1) {
      window.quickViewBootstrap.bootstrap();
    }
  },
};

window.quickViewBootstrap.initialize();



// WEBPACK FOOTER //
// ./src/reactjs/quickView/QuickViewBootstrap.js